const lastLoginWorkDayStampKey = "lastLoginWorkDayStamp";

export function getCurrentWorkDayStamp() {
    const d = new Date();
    d.setHours(d.getHours() - 4); // считаем время от 0:00 до 3:59 следующего дня все еще "сегодняшним рабочим днем" (делаем сдвиг, чтобы оставаться в одной дате)
    d.setHours(0, 0, 0, 0); // "округляем" до полуночи
    return String(d.getTime() / 1000); // берем стемп в секундах в виде строки как уникальный идентификатор "рабочего дня"
}

export function setLastLoginWorkDayStamp(stamp) {
    localStorage.setItem(lastLoginWorkDayStampKey, stamp);
}

export function getLastLoginWorkDayStamp() {
    return localStorage.getItem(lastLoginWorkDayStampKey);
}

export function removeLastLoginWorkDayStamp() {
    localStorage.removeItem(lastLoginWorkDayStampKey);
}